
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gYv97", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fe6b7c91c4e0504e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $fe6b7c91c4e0504e$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Annuler',
    'fabric.linkPicker.button.insert': "Ins\xe9rer",
    'fabric.linkPicker.button.save': 'Enregistrer',
    'fabric.linkPicker.clearLink': 'Effacer',
    'fabric.linkPicker.clearLinkText': 'Effacer le texte',
    'fabric.linkPicker.hyperlink.searchLinkResults': "{count, plural, =0 {aucun r\xe9sultat} one {{count,number}\xa0r\xe9sultat trouv\xe9} other {{count,number}\xa0r\xe9sultats trouv\xe9s}}",
    'fabric.linkPicker.linkAriaLabel': 'Saisir ou coller un lien dans le champ',
    'fabric.linkPicker.linkHelperTextAriaLabel': "Texte d'aide d'affichage du lien",
    'fabric.linkPicker.linkHelperTextLabel': "Ajoutez un titre ou une description \xe0 ce lien",
    'fabric.linkPicker.linkInvalid': 'Saisissez une URL valide.',
    'fabric.linkPicker.linkLabel': 'Lien',
    'fabric.linkPicker.linkPlaceholder': 'Collez un lien',
    'fabric.linkPicker.linkTextAriaLabel': "Texte d'affichage du lien",
    'fabric.linkPicker.linkTextLabel': "Texte d'affichage (facultatif)",
    'fabric.linkPicker.linkTextPlaceholder': "Texte \xe0 afficher",
    'fabric.linkPicker.listTitle.recentlyViewed': "R\xe9cemment consult\xe9s",
    'fabric.linkPicker.listTitle.results': "R\xe9sultats",
    'fabric.linkPicker.noEmbed': "La vue int\xe9gr\xe9e n'est pas prise en charge pour ce lien. <a>En savoir plus sur les raisons pour lesquelles certains liens intelligents n'affichent pas de contenu.</a>",
    'fabric.linkPicker.search.error.description': "Actualisez la page ou contactez le <a>support\xa0Atlassian</a> si le probl\xe8me se reproduit.",
    'fabric.linkPicker.search.error.heading': "Nous ne parvenons pas \xe0 charger les donn\xe9es.",
    'fabric.linkPicker.search.error.retry': 'Actualiser',
    'fabric.linkPicker.search.linkAriaLabel': "Les suggestions appara\xeetront au fur et \xe0 mesure que vous saisissez du texte dans le champ",
    'fabric.linkPicker.search.linkLabel': 'Rechercher ou coller un lien',
    'fabric.linkPicker.search.linkPlaceholder': "Recherchez des liens r\xe9cents ou collez un nouveau lien",
    'fabric.linkPicker.search.noResults.description': "R\xe9essayez avec un autre terme.",
    'fabric.linkPicker.search.noResults.heading': "Nous n'avons trouv\xe9 aucun r\xe9sultat correspondant \xe0 votre recherche.",
    'fabric.linkPicker.status.submitting': 'Envoi',
    'fabric.linkPicker.time.message.updated': "Mise \xe0 jour\xa0: {time}",
    'fabric.linkPicker.time.message.viewed': "Consultation\xa0: {time}",
    'fabric.linkPicker.unhandledError.description': 'Essayez de recharger la page.',
    'fabric.linkPicker.unhandledError.heading': "Une erreur s'est produite."
};

});


//# sourceMappingURL=fr.ed6b76af.js.map
